import { appClientConfig } from '@/app/utils/appClientConfig';
import { MixpanelProvider } from 'react-mixpanel-browser';

export const ProductAnalytics = ({ children }: { children: React.ReactNode }) => {
  const enableLocalDebug = !appClientConfig.isLive;

  return (
    <MixpanelProvider
      token={appClientConfig.mixPanelToken ?? '45df7f84ca9209ad4155130142cd9c2c'}
      config={{
        debug: enableLocalDebug,
        cookie_domain: appClientConfig.webDomain,
        // We are using the EU endpoint for production while dev/uat is set to US
        ...(appClientConfig.isLive ? { api_host: 'https://api-eu.mixpanel.com' } : {}),
      }}
    >
      {children}
    </MixpanelProvider>
  );
};
